import { GetExtendAvailabilityRequest, GetExtendAvailabilityResponse } from '@numa-group/checkout-api';
import axios, { AxiosInstance } from 'axios';

import { IAuthService } from '@src/features/auth/services/i-auth-service';
import { ApiResponse } from '@src/types/api/response/api-response';

import { ExtendStayRepository } from './extend-stay.repository';

export class ExtendStayRepositoryAxios implements ExtendStayRepository {
  constructor(
    private axiosInstance: AxiosInstance,
    private authService: IAuthService,
  ) {}

  async getAvailabilityInfo(request: GetExtendAvailabilityRequest) {
    try {
      const apiToken = await this.authService.getAuthToken();

      const response = await this.axiosInstance.post<ApiResponse<GetExtendAvailabilityResponse>>(
        'extend-availability',
        request,
        { headers: { ...(apiToken && { Authorization: `Bearer ${apiToken}` }) } },
      );

      return response.data.data;
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.status === 404) {
        return null;
      }

      throw e;
    }
  }
}
